import React, { useState } from "react";
import { message } from "antd";
import RejectionModal from "./RejectionModal";
import DetailsModal from "./DetailsModal";
import {
  APPROVAL_STATUS,
  RESPOND_ACTION,
  respondToAgreementItem,
} from "../../utils/agreementMapping";

// Accept / reject / view handling shared by the login modal and the
// Agreement Tracking page. `onResponded(item, approvalStatus, remarks)` runs
// after the API confirms the action.
const useAgreementItemActions = (onResponded) => {
  const [respondingId, setRespondingId] = useState(null);
  const [rejectingItem, setRejectingItem] = useState(null);
  const [detailsTarget, setDetailsTarget] = useState(null);

  const accept = async (item) => {
    setRespondingId(item.id);
    const success = await respondToAgreementItem(item, RESPOND_ACTION.ACCEPT);
    setRespondingId(null);
    if (success) {
      message.success(`${item.name} accepted`);
      onResponded(item, APPROVAL_STATUS.APPROVED);
    } else {
      message.error("Could not accept, please try again");
    }
  };

  const reject = async (remarks) => {
    const item = rejectingItem;
    const success = await respondToAgreementItem(
      item,
      RESPOND_ACTION.REJECT,
      remarks,
    );
    if (!success) {
      message.error("Could not reject, please try again");
      return false;
    }
    setRejectingItem(null);
    message.success(`${item.name} rejected`);
    onResponded(item, APPROVAL_STATUS.REJECTED, remarks);
    return true;
  };

  const modals = (
    <>
      <RejectionModal
        open={Boolean(rejectingItem)}
        onCancel={() => setRejectingItem(null)}
        onSubmit={reject}
      />
      <DetailsModal
        target={detailsTarget}
        onClose={() => setDetailsTarget(null)}
      />
    </>
  );

  return {
    respondingId,
    accept,
    startReject: setRejectingItem,
    viewItem: (item) => setDetailsTarget({ item }),
    viewAgreement: (agreement) => setDetailsTarget({ agreement }),
    modals,
  };
};

export default useAgreementItemActions;
